import React from "react";
import { Container } from "../../components/container/Container";
import ProgressBar from "../ProgressBar/ProgressBar";
import CardWithNameOrTitle from "../Card/CardWithNameOrTitle";

const TwoSections = ({ dataSectionOne, dataSectionTwo }) => {
  return (
    <Container className="flex flex-col md:flex-row gap-8 mt-10">
      {/* Left Section */}
      {/* <div className="w-full md:w-1/2">
        {dataSectionOne.map((item, index) => (
          <ProgressBar key={index} segments={item} idx={index} />
        ))}
      </div> */}

      {/* Right Section */}
      {/* <div className="w-full md:w-full mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 ">
          {dataSectionTwo.map((item, index) => (
            <CardWithNameOrTitle key={index} data={item} />
          ))}
        </div>
      </div> */}
    </Container>
  );
};

export default TwoSections;
